import React from 'react';
import { Row, Col } from 'react-bootstrap/lib';
import styler from 'react-styling';

const style = styler `
  Loader
    padding: 15px
    &Calendar
      background-color: #F5F5F5
    &Scheduler
      background-color: #FFF
      z-index: 9
  LoadingBar
    width: 100%
    height: 20px
    border-radius: 5px
    &Calendar
      background: linear-gradient(270deg, #DBDBDB, #ECECEC, #DBDBDB, #ECECEC)
      background-size: 300% 100%;
      -webkit-animation: LoadingEventBar 1s linear infinite
      -moz-animation: LoadingEventBar 1s linear infinite
      animation: LoadingEventBar 1s linear infinite
    &Scheduler
      background: linear-gradient(270deg, #EFEFEF, #F8F8F8, #EFEFEF, #F8F8F8)
      background-size: 300% 100%;
      -webkit-animation: LoadingEventBar 1s linear infinite
      -moz-animation: LoadingEventBar 1s linear infinite
      animation: LoadingEventBar 1s linear infinite
`;

const EventLoading = (props: { displayName?: string }) => {
  const SchedulerLoading = (
    <div>
      <Col xs={3} style={style.Loader.Scheduler}>{props.displayName}</Col>
      <Col xs={9} style={style.Loader.Scheduler}>
        <div style={style.LoadingBar.Scheduler}>{''}</div>
      </Col>
    </div>);

  const CalendarLoading = (
    <Col xs={12} style={style.Loader.Calendar}>
      <div style={style.LoadingBar.Calendar}>{''}</div>
    </Col>);

  return (
    <Row className="multislots-user">
      {props.displayName ? SchedulerLoading : CalendarLoading}
    </Row>
    );
};

export default EventLoading;



// WEBPACK FOOTER //
// ./src/js/Components/Event/EventLoading.js